import { createFileRoute } from '@tanstack/react-router'
import { onlineManager } from '@tanstack/react-query'
import { Inbox } from '@/pages/inbox/Inbox'
import {
  getNotificationTabListQueryOptions,
  getNotificationsQueryOptions,
} from '@/queries/query/notification'
import { queryKeys } from '@/queries/keys'
import { InboxPageSearchSchema } from '@/schemas/page'

export const Route = createFileRoute('/inbox')({
  validateSearch: InboxPageSearchSchema,
  loaderDeps: ({ search }) => ({ tab: search.tab }),
  loader: ({ context, deps }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return [
        context.queryClient.ensureQueryData(
          getNotificationTabListQueryOptions(),
        ),
        context.queryClient.ensureInfiniteQueryData(
          getNotificationsQueryOptions({ category: deps.tab }),
        ),
      ]
    }
    return [
      context.queryClient.getQueryData(queryKeys.notification.tabList()),
      context.queryClient.getQueryData(
        queryKeys.notification.notifications({ category: deps.tab }),
      ),
    ]
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Inbox />
}
